import React from 'react'
import { Box, Typography } from '@mui/material'
import GaugeComponent from 'react-gauge-component'
import CountUp from 'react-countup'

import { useEffect, useRef, useState } from 'react'

function Gauge({ value, color = 'black', hyperOnboarding = false }) {
  const lastRef = useRef(0)
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    lastRef.current = value
  }, [value])

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        position: 'relative',
        width: 130,
        '&>.semicircle-gauge': {
          width: 90,
        },
        '&>.semicircle-gauge>svg': {
          height: 60,
          width: 120,
          transform: 'translate(0px, 0px)',
          overflow: 'visible',
        },
        '&>.semicircle-gauge>svg>g': {
          transform: 'translate(5px, 5px)',
        },
        '&>.semicircle-gauge>svg>g>g>text': {
          transform: 'translate(0px, 0px)',
        },
        '&>.semicircle-gauge>svg>g>g>circle': {
          transform: `translate(${
            (isNaN(value) ? 0 : value / 100) * 9 - 3
          }px, -6px)`,
          filter: 'drop-shadow(0px 2px 1.5px rgba(0,0,0,0.3))',
        },
      }}
    >
      <GaugeComponent
        key={width}
        type="semicircle"
        marginInPercent={{
          top: 0.048,
          bottom: 0.0,
          left: 0.0,
          right: 0.0,
        }}
        arc={{
          colorArray: ['#FF2F32', '#FFCA59', '#4CAF50'],
          padding: 0.04,
          width: 0.15,
          subArcs: [{ limit: 55 }, { limit: 75 }, { limit: 100 }],
        }}
        labels={{
          valueLabel: {
            hide: true,
            // style: {
            //   fill: color == 'white' ? '#fff' : '#262627',
            //   textShadow: 'none',
            //   fontSize: '150px',
            //   transform: 'translate(0px, -5px)',
            //   fontWeight: 700,
            // },
            formatTextValue: (value) => value,
          },
          tickLabels: {
            hideMinMax: true,
          },
        }}
        pointer={{
          type: 'blob',
          animate: false,
          animationDelay: 0,
          width: 40,
        }}
        value={value}
      />

      <Box
        sx={{
          textAlign: 'center',
          width: '50px',
          marginLeft: '-42.5%',
          marginTop: '20%',
        }}
      >
        {hyperOnboarding ? (
          <Typography variant="h2" fontWeight="800" color="#262627">
            ?
          </Typography>
        ) : (
          <CountUp
            start={lastRef.current}
            end={value}
            duration={0.5}
            style={{
              fill: color == 'white' ? '#fff' : '#262627',
              textAlign: 'center',
              textShadow: 'none',
              fontSize: '36px',
              fontWeight: 700,
            }}
          />
        )}
      </Box>
    </Box>
  )
}

export default Gauge
